/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


const mutations = {


  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu

  SET_CURRENT_MODULE_NAME(state, moduleName) {
    state.currentModuleName = moduleName
  },
  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE (state, value) {
    state.auth.layout.main_menu_layout_type_id = value ? 1 : 2
    state.isVerticalNavMenuActive = value
  },
  TOGGLE_REDUCE_BUTTON (state, val) {
    state.auth.layout.main_menu_collapsed = val
    state.reduceButton = val
  },
  UPDATE_MAIN_LAYOUT_TYPE (state, val) {
    state.mainLayoutType = val
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN (state, val) {
    state.verticalNavMenuItemsMin = val
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH (state, width) {
    state.verticalNavMenuWidth = width
  },

  UPDATE_NAVBAR_TYPE (state, val) {
    const navbar_types = {
      floating: 1, 
      static: 2, 
      sticky: 3,
      hidden: 4
    }

    const navbar_type_id = navbar_types[val]

    state.auth.layout.navbar_type_id = navbar_type_id
  },

  UPDATE_NAVBAR_COLOR (state, val) {

    state.auth.layout.navbar_color = val

  },

  UPDATE_RTL (state, val) {
    state.auth.layout.rtl = val
  },

  UPDATE_SCROLL_TO_TOP (state, val) {
    state.auth.layout.scroll_to_top_button = val
  },

  UPDATE_ROUTER_TRANSITION (state, val) {
    const transitions = {
      'zoom-fade': 1, 
      'slide-fade': 2, 
      'fade-bottom': 3, 
      'fade': 4, 
      'zoom-out': 5, 
      'none': 6
    }

    const transition_type_id = transitions[val]

    state.auth.layout.animation_type_id = transition_type_id
  },

  UPDATE_FOOTER_TYPE (state, val) {
    const footer_types = {
      static: 1,
      sticky: 2,
      hidden: 3
    }

    const footer_type_id = footer_types[val]

    state.auth.layout.footer_type_id = footer_type_id
  },


  // VxAutoSuggest

  UPDATE_STARRED_PAGE (state, payload) {

    // find item index in search list state
    const index = state.navbarSearchAndPinList['pages'].data.findIndex((item) => item.url === payload.url)

    // update the main list
    state.navbarSearchAndPinList['pages'].data[index].is_bookmarked = payload.val

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(state.navbarSearchAndPinList['pages'].data[index])
    } else {
      // find item index from starred pages
      const index = state.starredPages.findIndex((item) => item.url === payload.url)

      // remove item using index
      state.starredPages.splice(index, 1)
    }
  },

  // Navbar-Vertical

  ARRANGE_STARRED_PAGES_LIMITED (state, list) {
    const starredPagesMore = state.starredPages.slice(10)
    state.starredPages     = list.concat(starredPagesMore)
  },
  ARRANGE_STARRED_PAGES_MORE (state, list) {
    let downToUp                   = false
    const lastItemInStarredLimited = state.starredPages[10]
    const starredPagesLimited      = state.starredPages.slice(0, 10)
    state.starredPages             = starredPagesLimited.concat(list)

    state.starredPages.slice(0, 10).map((i) => {
      if (list.indexOf(i) > -1) downToUp = true
    })

    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited)
    }
  },


  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////

  TOGGLE_CONTENT_OVERLAY (state, val) { state.bodyOverlay       = val   },
  UPDATE_PRIMARY_COLOR (state, val)   { 
    state.auth.layout.theme_color = val
    state.themePrimaryColor = val
  },
  UPDATE_THEME (state, val) { 

    let theme_id = 1

    switch (val) {
    case 'light':
      theme_id = 1
      break
    case 'dark':
      theme_id = 2
      break
    case 'semi-dark':
      theme_id = 3
      break
    default:
      break
    }

    // state.auth.layout.theme_color = val

    state.auth.layout.theme_mode_id = theme_id

    state.theme = val
  },
  UPDATE_WINDOW_WIDTH (state, width)  { state.windowWidth       = width },
  UPDATE_WINDOW_SCROLL_Y (state, val) { state.scrollY           = val   },


  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  // Updates user info in state and localstorage
  UPDATE_USER_INFO (state, payload) {

    // Get Data localStorage
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || state.AppActiveUser

    for (const property of Object.keys(payload)) {

      if (payload[property] !== null) {
        // If some of user property is null - user default property defined in state.AppActiveUser
        state.AppActiveUser[property] = payload[property]

        // Update key in localStorage
        userInfo[property] = payload[property]
      }


    }
    // Store data in localStorage
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  }
}

export default mutations

